










import { Component, Mixins, Prop, Vue } from 'vue-property-decorator';
import { downloadPredicates } from '@/services/Downloads';
import { DownloadListenerMixin } from './DownloadListenerMixin';

@Component({})
export class DownloadButton extends Mixins(DownloadListenerMixin) {
	private get isEnabled(): boolean {
		return this.download === null || downloadPredicates.isCompleted(this.download);
	}
}

export default DownloadButton;
